import type { FC } from 'react';

interface MemberAvatarProps {
  name: string;
  avatarUrl?: string | null;
}

// The member's picture, or the first letter of their name without one.
export const MemberAvatar: FC<MemberAvatarProps> = ({ name, avatarUrl }) =>
  avatarUrl ? (
    <img src={avatarUrl} alt="" className="size-8 shrink-0 rounded-full object-cover" />
  ) : (
    <span
      className="flex size-8 shrink-0 items-center justify-center rounded-full bg-black/10 text-xs font-medium text-black"
      aria-hidden="true"
    >
      {name.slice(0, 1)}
    </span>
  );
